import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SidebarService {
  // TODO: Make this an enum
  // Fully opened = 0
  // Partially open (icons visible) = 1
  // Closed = 2
  sidebarState: Number;
  
  // user$: Observable<User>;
  // private userSubject: Subject<User>;

  constructor() {
    this.sidebarState = 0;
    // this.userSubject = new Subject<User>();
    // this.user$ = this.userSubject.asObservable();
  }

  open() {
    this.sidebarState = 0;
  }

  openPartial() {
    this.sidebarState = 1;
  }

  close() {
    this.sidebarState = 2;
  }
}